var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.hasTransition ? 'slide-and-appear' : 'no-transition'},on:{"after-enter":_vm.afterEnter}},[(_vm.isVisible || _vm.isTemporarilyVisible)?_c('div',{staticClass:"slide-content__block",class:{
      'slide-content__block--temp-visible': _vm.isTemporarilyVisible,
    }},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }